import Axios from '@/axios'

// 上传文件 base64数据
// 接口权限名：web:fileUpload:create
export const FileUploadBase64 = data => {
  return Axios({
    url: '/device-manager/web-api/file-upload/upload_base64',
    method: 'POST',
    type: 'json',
    data
  })
}
